/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Login from "../auth/Login";
import Modal from "../common/Modal";

/*REDUX*/
import { setLanguage } from "../../actions/authActions";
import { pushFormOffline } from "../../actions/formActions";

/*FUNCTION*/
import uuid from "../../validation/uuid";

/*DATA*/
import dict from "../../validation/dict.json";

/*CONST*/

// Helper function to detect and parse URLs into clickable <a> tags
const renderTextWithLinks = (text) => {
  if (!text) return text;

  // Regex to match URLs starting with http:// or https://
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.split(urlRegex).map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline", color: "#007bff" }} // Optional basic styling
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

const Title = ({
  auth,
  form,
  step,
  setLanguage: setLanguageAction,
  pushFormOffline: pushFormOfflineAction,
}) => {
  //local state
  const [modal_login, set_modal_login] = useState(false);

  //global props
  const { geo_layer_wo_geojson, loading, itemLoading } = form;
  const { isAuthenticated, version } = auth;

  const toggle_login = () => {
    set_modal_login(!modal_login);
  };

  const onSetLanguage = (language) => {
    setLanguageAction(language);
  };

  const onClickOffline = (is_saved_offline) => {
    if (!is_saved_offline) {
      // Create a shallow copy to avoid mutating redux state directly
      const geo_layer_wo_geojson_copy = { ...geo_layer_wo_geojson };
      geo_layer_wo_geojson_copy.id_offline = uuid();
      pushFormOfflineAction(geo_layer_wo_geojson_copy);
    }
  };

  const get_color_style = (current_step, number_step) => {
    if (current_step === number_step) {
      return {
        backgroundColor: "#7cc735ff",
        color: "#ffffff",
      };
    } else {
      return {
        backgroundColor: "#ffffff",
        color: "#909598",
      };
    }
  };

  //local storage
  const language = localStorage?.language ? localStorage?.language : "ina";

  let form_list_offline = [];
  try {
    form_list_offline = localStorage.form_list_offline
      ? JSON.parse(localStorage.form_list_offline)
      : [];
  } catch (error) {
    // ignore parsing error
  }

  const is_saved_offline = form_list_offline?.some(
    (item) => item?.geo_layer_wo_geojson?._id === geo_layer_wo_geojson?._id,
  );

  // Determine Content Status
  const is_form_login_req = geo_layer_wo_geojson?.is_form_login_req;
  const api_status = geo_layer_wo_geojson?.api_status;
  const is_not_found =
    !loading &&
    !geo_layer_wo_geojson?._id &&
    itemLoading !== "getFieldsPrivate" &&
    itemLoading !== "get_feature";

  let text;
  let description = null;
  let login_button = null;
  let show_content = false; // Decides whether to show offline button & images

  if (
    loading &&
    (itemLoading === "getFieldsPrivate" || itemLoading === "get_feature")
  ) {
    text = "Loading...";
  } else if (is_form_login_req && !isAuthenticated) {
    // BLOCK: Form requires login and user is not authenticated
    text =
      dict?.["Survei ini mengharuskan kamu untuk masuk akun."]?.[language] ||
      "Survei ini mengharuskan kamu untuk masuk akun.";
    login_button = (
      <button className="button" id="blue" onClick={toggle_login} type="button">
        Login
      </button>
    );
  } else if (
    api_status === "memang tidak diperbolehkan untuk mengakses form" ||
    api_status === "layer_not_found" ||
    is_not_found
  ) {
    // BLOCK: Backend explicitly denied access or layer is fully not found
    if (isAuthenticated) {
      text =
        "Form tidak bisa dimuat, ada kemungkinan form tidak publik atau tautan form yang Anda masukkan salah.";
    } else {
      text =
        "Form tidak bisa dimuat, ada kemungkinan form tidak publik atau tautan form yang Anda masukkan salah. Silakan login terlebih dahulu.";
      login_button = (
        <button
          className="button"
          id="blue"
          onClick={toggle_login}
          type="button"
        >
          Login
        </button>
      );
    }
  } else if (geo_layer_wo_geojson?._id) {
    // SUCCESS: Loaded and allowed
    text = geo_layer_wo_geojson?.name || "MAPID FORM";
    description = geo_layer_wo_geojson?.description;
    show_content = true;
  } else {
    text =
      "Form tidak bisa dimuat, ada kemungkinan form tidak publik atau tautan form yang Anda masukkan salah. Silakan login terlebih dahulu.";
    login_button = (
      <button className="button" id="blue" onClick={toggle_login} type="button">
        Login
      </button>
    );
  }

  const modal_login_content = modal_login && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_login}
      onClose={toggle_login}
    >
      <div className="box-body">
        <Login isNav={true} toggle_login={toggle_login} />
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_login_content}
      <section className="status_box">
        <section className="parent_center" style={{ width: "100%" }}>
          <button
            className="button_lingkaran margin"
            style={get_color_style(step, 1)}
            type="button"
          >
            1
          </button>
          <button
            className="button_lingkaran margin"
            style={get_color_style(step, 2)}
            type="button"
          >
            2
          </button>
          <button
            className="button_lingkaran margin"
            style={get_color_style(step, 3)}
            type="button"
          >
            3
          </button>
        </section>

        <section>
          <div className="text_inferior" id="white_text">
            {dict?.["Pilih bahasa"]?.[language]}{" "}
          </div>
          <button
            className="button_small"
            id={language === "ina" ? "green" : "grey"}
            onClick={() => onSetLanguage("ina")}
            type="button"
          >
            INA
          </button>{" "}
          <button
            className="button_small"
            id={language === "eng" ? "green" : "grey"}
            onClick={() => onSetLanguage("eng")}
            type="button"
          >
            ENG
          </button>
          <br />
          <div className="button_small margin_top" id="white">
            {dict["Version"][language]} {version}
          </div>
          <Link
            to="/menu/dashboard"
            className="button_small margin_top"
            id="white"
          >
            Home
          </Link>
        </section>
      </section>

      <section className="container_light margin_bottom" id="white_background">
        <div>
          <h1 className="text_big text_left">{text}</h1>
          {description && (
            <h1 className="text_small text_left">
              {renderTextWithLinks(description)}
            </h1>
          )}
          {login_button && (
            <div style={{ marginTop: "15px" }}>{login_button}</div>
          )}
        </div>

        {show_content && (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <button
              onClick={() => onClickOffline(is_saved_offline)}
              className="button_save_offline margin_top"
              id={is_saved_offline ? "button_save_offline_active" : ""}
              type="button"
            >
              {!is_saved_offline
                ? dict["Simpan offline"][language]
                : dict["This form is available offline"][language]}
            </button>
          </div>
        )}
      </section>

      {show_content && geo_layer_wo_geojson?.picture_url && (
        <div
          className="margin_bottom"
          style={{
            backgroundImage: `url(${geo_layer_wo_geojson?.picture_url})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundColor: "#dedede",
            width: "100%",
            paddingBottom: "25%",
            borderRadius: "10px",
            marginTop: "10px",
          }}
        />
      )}
      {show_content && geo_layer_wo_geojson?.picture_url_square?.[0] && (
        <div
          className="margin_bottom"
          style={{
            backgroundImage: `url(${
              geo_layer_wo_geojson?.picture_url_square
                ? geo_layer_wo_geojson?.picture_url_square[0]?.url
                : ""
            })`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundColor: "#dedede",
            width: "100%",
            paddingBottom: "100%",
            borderRadius: "10px",
            marginTop: "10px",
          }}
        />
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  form: state.form,
});

export default connect(mapStateToProps, {
  setLanguage,
  pushFormOffline,
})(Title);
